<template>
  <div class="dados-fisicos-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
    >
      <field-group-form>
        <v-row>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <v-text-field
              v-model="fields.peso"
              v-mask="['##,##', '###,##']"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :label="$t('Peso_Kg')"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <v-text-field
              v-model="fields.altura"
              v-mask="['#,##']"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :label="$t('Altura_m')"
            />
          </v-col>
        </v-row>
      </field-group-form>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { updateData } from "@/services";
export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm },
  data: () => ({
    fields: {
      peso: "",
      altura: "",
    },
  }),
  watch: {
    "store.showModalDataForm"() {
      this.fields = { ...this.fields, ...this.data };
      this.fields.peso = this.$options.filters.number(
        Number(this.fields.peso),
        "0.00",
        {
          decimalSeparator: ",",
          thousandsSeparator: "",
        }
      );
      this.fields.altura = this.$options.filters.number(
        Number(this.fields.altura),
        "0.00",
        {
          decimalSeparator: ",",
          thousandsSeparator: "",
        }
      );
    },
  },
  computed: {
    store() {
      return this.$store.state;
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);
  },
  methods: {
    onSave() {
      this.fields.peso = this.convert(this.fields.peso);
      this.fields.altura = this.convert(this.fields.altura);

      updateData(this, "tagFuncionario", this.fields);
    },
    convert(value) {
      return this.$options.filters.number(
        Number(String(value).replace(",", ".")),
        "0.00",
        {
          decimalSeparator: ".",
          thousandsSeparator: "",
        }
      );
    },
  },
};
</script>

<style scoped></style>
